import { createAction, props } from "@ngrx/store";
import {
  IDeleteUserSkill,
  IDeleteUserSkills,
} from "@skills-app/models/deleteUserSkill";
import ISkillNodeWithRating from "@skills-app/models/skillNodeWithRating";

const prefix = "[Add Skill to Profile]";

export const requestUpdateUserSkill = createAction(
  `${prefix} Request Update User Skill`,
  props<{ azureId: string; skillMapping: ISkillNodeWithRating }>(),
);
export const requestDeleteUserSkill = createAction(
  `${prefix} Request Delete User Skill`,
  props<{ deleteUserSkill: IDeleteUserSkill }>(),
);
export const requestDeleteMultipleUserSkills = createAction(
  `${prefix} Request Delete Multiple User Skill`,
  props<{ deleteUserSkills: IDeleteUserSkills }>(),
);
export const clearSelectedSkill = createAction(
  `${prefix} Clear Selected Skill`,
);
